import { useEffect } from "react";
import { Userpilot } from "userpilot";

import useUserStore from "@store/useUserStore";
import { getFullNameOrEmail } from "@utils/tags.util";
import { platform } from "@platform/index";
import { getHostAppVersion } from "@platform/utils/host.util";
import capitalize from "lodash/capitalize";

const USERPILOT_TOKEN = process.env.REACT_APP_USERPILOT_TOKEN;

export function useUserpilot() {
  const { activeUser } = useUserStore();

  useEffect(() => {
    if (Userpilot && typeof Userpilot.initialize === "function") {
      Userpilot.initialize(USERPILOT_TOKEN);
    } else {
      console.warn("Userpilot SDK is not initialized");
    }
  }, []);

  useEffect(() => {
    if (activeUser) {
      const { id, email, organization } = activeUser;
      const name = getFullNameOrEmail(activeUser);
      const company = organization?.title ?? "";
      const title = activeUser?.title?.title ?? "";
      const platformName = capitalize(platform?.current ?? "");
      const hostAppVersion = getHostAppVersion();
      
      Userpilot.identify(id, {
        email,
        name,
        company,
        title,
        "Platform": platformName,
        "Platform Version": hostAppVersion,
      });
    }
  }, [activeUser]);

  const track = (event: string, meta?: Object) => {
    Userpilot.track(event, meta);
  };
  
  return { track };
}
